import React, { Component } from "react";
import { connect } from "react-redux";
import * as postActions from "../../store/action/post";
import * as configActions from "../../store/action/config";
import moment from "moment";
import Link from "src/components/link";
import Select from "react-select";
import * as _ from "lodash";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

import Input from "../../components/input/Input";
import ApiService from "../../services/ApiService";
import { ToastContainer, toast } from 'react-toastify';
import { filtersToQueryString } from "../../utils/post-filter";
import GAService from "../../services/GAService";
// import * as jsPDF from 'jspdf'

import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
class Pageviews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      preparingData: false,
      listPost: [],
      filters: {}
    }
  }
  

  updatePageviewData = () => {
    this.props.handleStartUpdate();
    let filters = JSON.parse(JSON.stringify(this.props.filters));
    filters.limit.value = -1;
    let queryString = filtersToQueryString(filters, true);
    const asyncForEach = async (array, callback) => {
        for (let index = 0; index < array.length; index++) {
            await callback(array[index], index, array)
        }
    }
    this.setState({preparingData: true}, () => {
      let countItem = 0;
      ApiService.get(`/posts/rolyalties?pr_type=0${queryString}`).then(async (result) => {
        // console.log(result);
        let postList = result.posts;
        const totalItem = postList.length;
        let lstTmp = [];
        let lstError = [];
        await asyncForEach(postList, async (post) => {
          try{
            const url = post.post_url;
            if(!url) {
                toast.error(`Không tìm thấy Bài Viết`);
                return;
            }

            let increment_id;
            if(post.increment_id){
              increment_id = post.increment_id;
            }else{
              const groupId = /-(\d+)\.html/.exec(url);
        
              if (groupId && groupId[1]) {
                  increment_id = groupId[1];
              }
            }
            if(!increment_id) {
                toast.error(`Không tìm thấy Bài Viết`);
                return;
            }
            
            await GAService.getViewByID(increment_id).then(
                result => {
                    if(result.status){
                        toast.success(`Đã Update Pageview cho bài viết: ${post.title}`)
                        countItem++;
                        this.props.handleUpdateItemPostPageview(countItem / totalItem * 100);
                    // this.setState({
                    //     pageviews: result.pageviews,
                    //     timeOnPage: result.timeOnPage
                    // })
                    }
                    else{
                    toast.error(`Không Update Pageview cho bài viết`);
                    }
                }
            ).catch((error) => {
              console.error(error);
            });
          }catch(e){
            lstError.push(post);
            console.error(e);
          }
            
        })
        if(lstError.length > 0){
          let retryErrors = [];
          await asyncForEach(lstError, async (post) => {
            try{
              const url = post.post_url;
              if(!url) {
                  toast.error(`Không tìm thấy Bài Viết`);
                  return;
              }
  
              let increment_id;
              if(post.increment_id){
                increment_id = post.increment_id;
              }else{
                const groupId = /-(\d+)\.html/.exec(url);
          
                if (groupId && groupId[1]) {
                    increment_id = groupId[1];
                }
              }
              if(!increment_id) {
                  toast.error(`Không tìm thấy Bài Viết`);
                  return;
              }
              
              await GAService.getViewByID(increment_id).then(
                  result => {
                      if(result.status){
                        toast.success(`Đã Update Pageview cho bài viết: ${post.title}`)
                        countItem++;
                        this.props.handleUpdateItemPostPageview(countItem / totalItem * 100);
                      }
                      else{
                        toast.error(`Không Update Pageview cho bài viết`);
                      }
                  }
              ).catch((error) => {
                console.error(error);
              });
            } catch (e) {
              retryErrors.push(post);
              console.error(e);
            }
          });
          if (retryErrors.length > 0) {
            toast.error(`Có ${retryErrors.length} bài viết vẫn lỗi sau khi thử lại!`);
          }
        }
        console.log('Done');
        toast.success(`Đã Update Pageview cho ${postList.length} bài viết`)
        this.setState({
          listPost: result.posts, showModal: true, preparingData: false
          // filters
        });
        this.props.handleUpdate();
      });
      })
    }

  componentDidMount() {
    this.setState({
      filters: JSON.parse(JSON.stringify(this.props.filters)),
    });
  }

  formatNumber(number) {
    var tier = (Math.log10(number) / 3) | 0;
    if (tier == 0) return number;
    var suffix = SI_SYMBOL[tier];
    var scale = Math.pow(10, tier * 3);
    var scaled = number / scale;

    return parseFloat(scaled.toFixed(1)) + suffix;
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props.filters) !== JSON.stringify(this.state.filters)) {
      this.setState({filters: JSON.parse(JSON.stringify(this.props.filters))})
    }
  }

  render() {
    const { filters } = this.props;
    const {preparingData} = this.state;
    const category = filters.category.value !== '' ? '-' + filters.category.value : '';
    const editor = filters.editor.value !== '' ? '-' + filters.editor.value : '';
    const editor_type = filters.editor_type.value !== '' ? '-' + filters.editor_type.value : '';
    const start_date = moment(filters.start_date.value).format("DD/MM");
    const end_date = moment(filters.end_date.value).format("DD/MM");

    return (
      <>
      <Button 
      className="btn btn-primary btn-block" onClick={this.updatePageviewData}
      disabled={preparingData}
      >
        <i className={`fas fa-sync mr-2 ${preparingData ? 'fa-spin' : ''}`}></i>
        {preparingData ? 'Updating...' : 'Update View'} 
                  
      </Button>
      {/*preparingData &&
        <div className="saveblock">
            <div className="saveblock-content">
                <p>Đang xử lý...</p>
                <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
                </div>
            </div>
        </div>
      */}
      </>
    )
  }
}

export default connect(
  store => {
    return {
      profile: store.loginInfo.userInfo,
      router: store.router,
      posts: store.post.listRoyalties,
      totalPosts: store.post.totalRoyalties,
      totalMoneyEditor: store.post.totalMoneyEditor,
      totalMoney: store.post.totalMoney,
      totalMoneyPhoto: store.post.totalMoneyPhoto,
      config: store.config
    };
  },
  dispatch => {
    return {
      getListPost: value => {
        dispatch(postActions.getListRoyalties(value));
      }
    };
  }
)(Pageviews);
